<template>
    <ModalComponent
        name="editar-categoria"
        title="Editar categoría"
        v-on:close="() => close()"
    >
        <FormComponent
            :categoria="categoriaTemporal"
            :loading="loading"
            @terminado="editarCategoria"
        />
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormComponent from '@/components/backend/productos/categorias/FormComponent';

    export default {
        props: {
            categoria: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                categoriaTemporal: {}
            }
        },
        methods: {
            editarCategoria() {
                this.loading = true;
                this.categoriaTemporal.category_id = this.categoriaTemporal.id;

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.categorias.editar'), this.categoriaTemporal).then(res => {
                    this.$toast.success(res.data.message);
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                }).finally(() => {
                    this.loading = false;
                    this.close(true);
                });
            },
            close(reload) {                
                this.$emit('close', 'editar-categoria', reload);
            }
        },
        watch: {
            categoria(newVal) {
                this.categoriaTemporal = Object.assign({}, newVal);
            }
        },
        components: {
            ModalComponent, FormComponent
        }
    }
</script>